import GetContactIdMappingByIdRequestModelBase from '../_generated/modelBases/get-contact-id-mapping-by-id-request-model-base';

export default class GetContactIdMappingByIdRequestModel extends GetContactIdMappingByIdRequestModelBase {
  // For instructions on how to use Models visit:
  // https://glittrsoftware.visualstudio.com/glittr.core/_wiki/wikis/glittr.core.wiki/429/ServiceModels-DTOs
}
